import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  let data = isSuccessResponse(response)
  return data
}

const getConfigInsertRequest = (mid: string, configList: any[], isUpdateRequired: boolean) => {
  return {
    mid: mid,
    configListDetails: configList,
    updateRequired: isUpdateRequired ? 'Y' : 'N',
  }
}

const insertMetaConfig = (mid: string, config: any[], isUpdateRequired: boolean, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.configListMetaInsert),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: getConfigInsertRequest(mid, config, isUpdateRequired),
  }

  return executeRequest(request)
    .then((resp) => responseParser(resp))
    .catch((error) => {
      throw error
    })
}

export { insertMetaConfig }
